module.exports = __webpack_public_path__ + "static/media/5DPO21.4b6b7a46.jpg";